<template>
    <div>
        <base-steps :hideButtons="true" ref="printSteps">
            <div> <!-- STEP 1 -->
				<div v-if="loading" class="login-loading">
					<base-loading/>
				</div>

                <div v-if="!confirmStep"> <!-- Antes da tentativa -->
                    <base-card>
                        <base-question text="Selecione uma impressora"/>
                        <!-- <span>Encontrados</span> -->

                        <base-radio v-for="(printer, index) in printers" v-model="newPrinter.name" :option="printer.name" :key="index" :label="printer.name" :family="'printers'" class="mt_15"/>
                        <!-- <span v-if="paired.length > 0">Pareados</span> -->

						<!-- <base-radio @click="selectBluetoothDevice(device)" v-for="(device, index) in paired" :key="index" :label="device.name" :option="device.name" />
                        <base-radio @click="selectBluetoothDevice(device)" v-model="newPrinter.name" v-for="(device, index) in founded" :key="index" :label="device.name" :option="device.name" /> -->
                    </base-card>
                </div>

                <div v-else> <!-- Depois da tentativa -->
                    <base-card>
                        <base-question class="text-center mb_0" text="Tentativa de impressão realizada! Favor conferir se algo foi impresso."/>
                    </base-card>
                </div>
            </div>

            <div> <!-- STEP 2 -->
				<div v-if="loading" class="login-loading">
					<base-loading/>
				</div>

                <div v-if="!confirmStep"> <!-- Antes da tentativa -->
                    <base-card>
                        <base-question text="Escolha a marca da impressora"/>
                        <base-radio :label="'Bematech'" :family="'printerbrand'" class="mt_15" :option="'bematech'" v-model="newPrinter.brand" />
                        <base-radio :label="'Epson'" :family="'printerbrand'" class="mt_15" :option="'epson'" v-model="newPrinter.brand" />
                        <base-radio :label="'Outra'" :family="'printerbrand'" class="mt_15" :option="'other'" v-model="newPrinter.brand" />
                    </base-card>

                    <base-card>
                        <base-question text="Escolha o tamanho do papel"/>
                        <base-radio :label="'80mm'" :family="'papersize'" class="mt_15" :option="'80'" v-model="newPrinter.width" />
                        <base-radio :label="'56mm'" :family="'papersize'" class="mt_15" :option="'56'" v-model="newPrinter.width" />
                    </base-card>
                </div>

                <div v-else> <!-- Depois da tentativa -->
                    <base-card>
                        <base-question class="text-center mb_0" text="Teste impresso com sucesso! Verfique se o estilo está do seu agrado, caso não, teste outras configurações."/>
                    </base-card>
                </div>
            </div>
        </base-steps>
    </div>
</template>

<script>
import BaseSteps from '@/components/Steps';
import BaseButton from '@/components/Button';
import BaseCard from '@/components/Card';
import BaseRadio from '@/components/Radio';
import BaseCheckbox from '@/components/Checkbox';
import BaseQuestion from '@/components/Question';
import BaseLoading from '@/components/Loading';

export default {
    props: {
        printers: {},
		devices: {},
		categories: {},
    },
    data() {
        return{
            newPrinter: {
                name: '',
				mac: '',
				brand: 'other',
                width: '80',
                encode: 1,
                type: {
                    pedidos: true,
                    caixa: true
				},
				layouts: [],
            },
            currentStep: 1,
            selectedPrinter: '',
			confirmStep: false,
			loading: false,
        }
	},
    methods: {
        testPrint() {
			this.loading = true;

			this.$emit('testPrint', this.newPrinter);

			setTimeout(() => {
				this.confirmStep = true;
				this.loading = false;
			}, 3000);
		},
		setConfirmStep() {
			this.confirmStep = !this.confirmStep;

			this.$emit('confirmStep');
		},
        tryPrint() {
			this.loading = true;

			this.$emit('tryPrint', this.newPrinter);

			setTimeout(() => {
				this.confirmStep = true;
				this.loading = false;
			}, 3000);
        },
        next() {
			this.currentStep += 1;
            this.$refs.printSteps.next();
            this.confirmStep = false;
        },
        addPrinter() {
            this.$emit('addPrinter', this.newPrinter);
			this.confirmStep = true;

			this.finish();
        },
        finish() {
            this.currentStep = 1;
            this.selectedPrinter = '';
            this.confirmStep = false;
			this.$emit('finish');

			this.$refs.printSteps.current = 1;
        },
        selectBluetoothDevice(device) {
            this.newPrinter.bluetooth = true
            this.newPrinter.name = device.name
			this.newPrinter.mac = device.address

			debugger
        }
    },
    computed: {
        paired () {
            return this.devices && this.devices.data && this.devices.data.paired ? this.devices.data.paired : []
        },
        founded () {
            return this.devices && this.devices.data && this.devices.data.found ? this.devices.data.found : []
        }
    },
    components: {
        BaseSteps,
        BaseButton,
        BaseCard,
        BaseRadio,
        BaseCheckbox,
		BaseQuestion,
		BaseLoading,
    }
}
</script>
<style scoped>
    .check{
        font-size: 3.6em;
        text-align: center;
        margin-bottom: 15px;
        color: var(--default);
    }

	.login-loading{
		position: absolute;
		top: calc(50% - 40px);
		left: calc(50% - 40px);
	}

	.login-loading + div{
		opacity: 0;
		pointer-events: none;
	}
</style>